import React, { useMemo } from 'react';
import ProofOfDocumentCompactV2 from './ProofOfDocumentCompactV2';
import LinkifiedText from './LinkifiedText';
import { buildDocTypeAlias, resolveDocTypeRow } from './docTypeAlias';
import { DOC_STATUS, PARSE_STATE } from '../../../../hooks/useRequiredDocuments';
import { resolveDocTypeMeta } from '../../../../util/docTypeRuleMeta';

const PARSE_LABELS = {
    [PARSE_STATE.READ]: { text: 'Read', modifier: 'read' },
    [PARSE_STATE.READING]: { text: 'Reading…', modifier: 'reading' },
    [PARSE_STATE.UNREADABLE]: { text: 'Could not be read', modifier: 'unreadable' },
};

const DocumentStatus = ({ status, parseState, parseError }) => {
    if (status !== DOC_STATUS.UPLOADED) return null;
    const parse = PARSE_LABELS[parseState];
    if (!parse) {
        return <span className="docfirst__status docfirst__status--uploaded">Uploaded</span>;
    }
    return (
        <span
            className={`docfirst__status docfirst__status--${parse.modifier}`}
            title={parseState === PARSE_STATE.UNREADABLE && parseError ? parseError : undefined}
        >
            {parse.text}
        </span>
    );
};

const EMPTY_DOC_TYPE_MAP = {};

const DocumentRequirementList = ({
    documents = [],
    recordId,
    asLabel,
    showStatus = true,
    onDocumentsChanged,
    docTypeMap = EMPTY_DOC_TYPE_MAP,
}) => {
    const alias = useMemo(() => buildDocTypeAlias(docTypeMap), [docTypeMap]);

    if (!documents.length) return null;

    return (
        <>
            {documents.map((requirement) => {
                const docTypeRow = resolveDocTypeRow(alias, requirement.documentType);

                const supportedFiles = docTypeRow?.fileExtensions?.length
                    ? docTypeRow.fileExtensions
                    : resolveDocTypeMeta(requirement.documentType, { docTypeMap }).supportedFiles;

                const showCategory = docTypeRow?.key || requirement.documentType;

                const type = requirement.documentType;

                const shortTitle = docTypeRow?.name && docTypeRow.name !== requirement.label
                    ? docTypeRow.name
                    : null;

                return (
                    <div
                        className="docfirst__row"
                        key={`${requirement.ownerId || 'business'}-${requirement.documentType}`}
                    >
                        <ProofOfDocumentCompactV2
                            dataTestId={`doc-${requirement.documentType}${requirement.ownerId ? `-${requirement.ownerId}` : ''}`}
                            recordId={recordId}
                            asLabel={asLabel}
                            label={shortTitle || <LinkifiedText text={requirement.label} />}
                            hint={shortTitle ? <LinkifiedText text={requirement.label} /> : undefined}
                            field={type}
                            showCategory={showCategory}
                            type={type}
                            ubo_id={requirement.ownerId || undefined}
                            supportedFiles={supportedFiles}
                            single
                            validateByAi={false}
                            onDocumentsChanged={onDocumentsChanged}
                        />
                        {showStatus && (
                        <DocumentStatus
                            status={requirement.status}
                            parseState={requirement.parseState}
                            parseError={requirement.parseError}
                        />
                    )}
                    </div>
                );
            })}
        </>
    );
};

export default DocumentRequirementList;

